module.exports = __webpack_public_path__ + "static/media/CGTS-logo.0c85ae8a.svg";